import {get} from "../utils";

export default host => token => get(`${host}/public/playlists/${token}`)
  .then(response => response.json())
  .then(json => json.data)
